<template>
  <div id="welcome" :class="{cogir: cogir}">

    <div class="header">
      <svgicon src="svg/logo.svg" v-if="!$store.state.cogir" :width="120" :height="120"></svgicon>
      <div class="logo-container" v-if="$store.state.cogir">
        <img class="logo" src="@/assets/img/logo-cogir.png">
      </div>
    </div>

    <div class="middle">
      <div class="content">
        <div class="title">
          <template v-if="cogir">{{$t('welcome.title_cogir')}}</template>
          <template v-if="!cogir">{{$t('welcome.title_humaniti')}}</template>
        </div>
        <div class="split"></div>
        <div class="description">
          <template v-if="cogir">{{$t('welcome.description_cogir')}}</template>
          <template v-if="!cogir">{{$t('welcome.description_humaniti')}}</template>
        </div>
        <div class="download">{{$t('welcome.download')}}</div>

        <template v-if="device === IOS_DEVICE || !device">
          <a class="btn btn-primary" :href="ios.cogir" v-if="cogir" target="_blank">
            <svgicon src="svg/apple.svg" :height="18" :width="18"></svgicon>
            {{$t('welcome.download_ios')}}
          </a>
          <a class="btn btn-primary" :href="ios.humaniti" v-if="!cogir" target="_blank">
            <svgicon src="svg/apple.svg" :height="18" :width="18"></svgicon>
            {{$t('welcome.download_ios')}}
          </a>
        </template>
        <template v-if="device === ANDROID_DEVICE || !device">
          <a class="btn btn-primary" :href="android.cogir" v-if="cogir" target="_blank">
            <svgicon src="svg/android.svg" :height="18" :width="18"></svgicon>
            {{$t('welcome.download_android')}}
          </a>
          <a class="btn btn-primary" :href="android.humaniti" v-if="!cogir" target="_blank">
            <svgicon src="svg/android.svg" :height="18" :width="18"></svgicon>
            {{$t('welcome.download_android')}}
          </a>
        </template>

        <router-link class="web" to="/login">{{$t('welcome.web')}}</router-link>

      </div>
    </div>

    <div class="info-footer">
      <div class="locale">
        <span :class="{active: $ts.state.locale == 'fr'}" @click="setLocale('fr')">Français</span>
        <span :class="{active: $ts.state.locale == 'en'}" @click="setLocale('en')">English</span>
      </div>
      <div class="copyright" >© 2020 {{$store.state.cogir ? 'Octopus' : 'Humaniti'}}. All Rights Reserved.</div>
    </div>

  </div>
</template>

<script>
  import Configuration from '../../core/Configuration';
  import moment from "moment";

  export default {
    name: "Welcome",

    data() {
      return {
        ANDROID_DEVICE: 'android',
        IOS_DEVICE: 'ios',

        android: {
          humaniti: 'https://play.google.com/store/apps/details?id=com.humanitimontreal.app',
          cogir: 'https://play.google.com/store/apps/details?id=net.cogir.octopus',
        },
        ios: {
          cogir: 'https://apps.apple.com/us/app/id1496979193',
          humaniti: 'https://apps.apple.com/us/app/id1485253321 '
        },
      }
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: false,
        showHeaderLeft: false,
        showFooter: false,
      });
    },

    computed: {
      device() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/windows phone/i.test(userAgent)) {
          return;
        }
        if (/android/i.test(userAgent)) {
          return this.ANDROID_DEVICE;
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return this.IOS_DEVICE;
        }
      },
      cogir() {
        return this.$store.state.cogir;
      }
    },

    methods: {
      setLocale(locale) {
        this.$ts.commit("setLocale", locale);
        Configuration.write("locale", locale);
        moment.locale(this.locale);
      }
    }
  }
</script>

<style lang="scss" scoped>
  #welcome {
    display: flex;
    flex-direction: column;
    padding: 0;
    height: 100%;
    background-color: #f2f3f4;
  }

  .middle {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      max-width: 420px;
      background-color: white;
      padding: 30px;
      text-align: center;
    }
  }

  .title {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .split {
    width: 150px;
    height: 5px;
    background-color: #ccc;
    margin-bottom: 20px;
  }

  .description {
    font-size: 14px;
    margin-bottom: 30px;
  }

  .download {
    font-weight: bold;
    margin-bottom: 10px;
  }

  .btn {
    fill: white;
    text-decoration: none;
    display: flex;
    min-width: 250px;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    padding: 14px 25px;

    .svgicon {
      margin-right: 10px;
    }
  }

  .logo {
    margin-top: 20px;
  }

  .web {
    font-size: 12px;
    color: #575757;
    margin-top: 25px;
    max-width: 315px;
  }

  .cogir {
    .btn-primary {
      background-color: #94c11f;
    }
  }

  .info-footer {
    text-align: center;
    font-size: 14px;
    color: #888;
    margin-bottom: 10px;
  }

  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 650px) {
    .header {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  .locale {
    margin-bottom: 4px;

    span:first-child {
      margin-right: 5px;
    }

    .active {
      font-weight: bold;
    }
  }
</style>